import { Directive, Input } from "@angular/core";
import { UntypedFormControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";

@Directive({
  selector: '[appUniqueItemValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: UniqueItemValidatorDirective, multi: true}],
  standalone: false
})
export class UniqueItemValidatorDirective implements Validator {

  @Input('appUniqueItemValidator') items: Set<string>;
  @Input() itemName: string;

  validate(control: UntypedFormControl): ValidationErrors | null {
    if (this.items.has(control.value)) {
      return {item: {messageKey: '(item) already exists', parameters: {item: this.itemName}}};
    }
    return null;
  }
}
